<template>
    <div>
        <h1 class="mb-4">Impressum</h1>

        <b-card-text>
            <b-img src="../assets/imprint.png" left width="250px" height="125px" alt="imprint"></b-img>
        </b-card-text>
    </div>
</template>

<script>
    export default {
        name: "Imprint"
    }
</script>

<style scoped>

</style>
